import { render, staticRenderFns } from "./MCalendarInput.vue?vue&type=template&id=70c2b511"
import script from "./MCalendarInput.vue?vue&type=script&lang=js"
export * from "./MCalendarInput.vue?vue&type=script&lang=js"
import style0 from "./MCalendarInput.vue?vue&type=style&index=0&id=70c2b511&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports